import { emptySplitApi } from "./InjectionEndpoint";


const categoryApi = emptySplitApi.injectEndpoints({
    
    endpoints: (build: any) => ({

        getCategories: build.query({
            query: (params: any) => `/api/azienda/${params.idAzienda}/categoria-lavoratore${params?.isSelect ? '?ExcludeDeleted=true' : ''}`,
            providesTags: ['agency']
        }),

        updateCategory: build.mutation({
            query: ({idAzienda, idCategoria, ...rest}: {idAzienda: number, idCategoria: number, rest:any}) => ({
                url: `/api/azienda/${idAzienda}/categoria-lavoratore/${idCategoria}`,
                method: 'PUT',
                body: rest
            }),
            invalidatesTags: ['agency']
        }),

        addCategory: build.mutation({
            query: ({idAzienda, ...rest}: any) => ({
                url: `/api/azienda/${idAzienda}/categoria-lavoratore`,
                method: 'POST',
                body: rest
            }),
            invalidatesTags: ['agency']
        }),

        deleteCategory: build.mutation({
            query: ({idAzienda, idCategoria}: {idAzienda: number, idCategoria: number}) => ({
                url: `/api/azienda/${idAzienda}/categoria-lavoratore/${idCategoria}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['agency']
        }),

    }),
});

export const {
    useAddCategoryMutation,
    useUpdateCategoryMutation,
    useDeleteCategoryMutation,
    useGetCategoriesQuery
} = categoryApi;